import { GENERAL_PRODUCT_INFORMATION_SECTIONS } from './sections'

const generalProductInformationV2Descriptor = Object.freeze({
    type: 'general-product-information',
    version: 2,
    defaultTitleKey: 'Page(ReceivedRequest):Component(GeneralProductInformation):title',
    fallbackTitle: 'General product information',
    defaultNavigationTitleKey: 'Page(ReceivedRequest):Component(GeneralProductInformation):navigation-title',
    fallbackNavigationTitle: 'Product information',
    defaultDescriptionKey: 'Page(ReceivedRequest):Component(GeneralProductInformation):description',
    fallbackDescription: 'Provide the product details required for this request.',
    capabilities: {
        repeatable: false,
        supportedModes: ['single', 'bulk'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: [
            'request.details',
            'product.card',
            'product.hierarchy',
            'product.concern-substances',
            'request.bulk-reply-candidates',
        ],
        writes: [
            'request.details',
            'product.card',
            'request.bulk-reply-candidates',
        ],
    },
    effects: {
        publishes: [
            'request.details.changed',
            'product.card.changed',
            'request.bulk-reply-candidates.changed',
        ],
        observes: [
            'product.concern-substances.changed',
        ],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            sections: {
                type: 'array',
                items: {
                    type: 'string',
                    enum: GENERAL_PRODUCT_INFORMATION_SECTIONS,
                },
                default: GENERAL_PRODUCT_INFORMATION_SECTIONS,
            },
            showCustomerProductName: { type: 'boolean', default: true },
            showCustomerProductIdentifier: { type: 'boolean', default: true },
            showCustomerProductDescription: { type: 'boolean', default: true },
            showCustomerProductReferenceOnlyWhenDifferent: { type: 'boolean', default: false },
        },
    },
    settingsUi: {
        sections: {
            control: 'multi-select',
            labelKey: 'Component(WorkflowBuilder):general-product-information-sections',
            optionsSource: {
                type: 'static',
                values: GENERAL_PRODUCT_INFORMATION_SECTIONS,
            },
        },
        showCustomerProductName: { control: 'switch' },
        showCustomerProductIdentifier: { control: 'switch' },
        showCustomerProductDescription: { control: 'switch' },
        showCustomerProductReferenceOnlyWhenDifferent: { control: 'switch' },
    },
})

export { generalProductInformationV2Descriptor }
export default generalProductInformationV2Descriptor
